module.exports = __webpack_public_path__ + "static/media/deposito.1becbe86.svg";